// Códigos da reforma tributária na NF (15/10/2026) — a régua da TELA.
//
// NBS, indicador da operação e classificação tributária: o padrão de cada
// código de serviço mora em financeiro.nf_codigos_tributacao (aba Recebimentos ›
// Códigos da NF) e a parcela pode trocar (aba Dados pra NF). As combinações
// válidas vêm do SERVIDOR (fin_listar_codigos_nf, comercial-engine/handlers/
// nfCodigosReforma.js, que também confere ao gravar) — a tela não tem cópia da
// tabela do Anexo VIII.

export type CombinacaoNf = {
  nbs: string; nbs_descricao: string | null; ind_operacao: string;
  class_trib: string; class_descricao: string | null; cst: string;
};
export type CodigoNf = {
  codigo: string; descricao: string;
  nbs: string | null; nbs_descricao: string | null;
  ind_operacao: string | null; class_trib: string | null;
  situacao: 'rascunho' | 'confirmado';
  observacao?: string | null;
  confirmado_por?: string | null; confirmado_em?: string | null;
  atualizado_em?: string | null;
  combinacoes: CombinacaoNf[]; tem_tabela: boolean;
};
export type TrocaNf = { nf_nbs: string; nf_ind_operacao: string; nf_class_trib: string };

export const TROCA_VAZIA: TrocaNf = { nf_nbs: '', nf_ind_operacao: '', nf_class_trib: '' };

const limpo = (v: unknown) => String(v ?? '').trim();

/** A chave de uma combinação no Select ('' = seguir o padrão). */
export function chaveCombo(nbs?: string | null, ind?: string | null, cls?: string | null): string {
  const n = limpo(nbs), i = limpo(ind), c = limpo(cls);
  return n && i && c ? `${n}|${i}|${c}` : '';
}

export function trocaDaChave(chave: string): TrocaNf {
  const [nbs, ind, cls] = String(chave || '').split('|');
  return nbs && ind && cls ? { nf_nbs: nbs, nf_ind_operacao: ind, nf_class_trib: cls } : { ...TROCA_VAZIA };
}

export function rotuloCombo(c: { nbs: string; nbs_descricao?: string | null; class_trib: string; class_descricao?: string | null }): string {
  return `NBS ${c.nbs}${c.nbs_descricao ? ` ${c.nbs_descricao}` : ''} · ${c.class_trib}${c.class_descricao ? ` ${c.class_descricao}` : ''}`;
}

/** O padrão do código de serviço da parcela (ou undefined). */
export function padraoDoCodigo(codigos: CodigoNf[], cnae?: string | null): CodigoNf | undefined {
  return codigos.find(c => c.codigo === limpo(cnae));
}

/**
 * A troca da parcela vale para este código de serviço? Vazia vale (segue o
 * padrão). Código com tabela: tem de ser uma das combinações. Sem tabela
 * (desenho técnico) ou sem a lista carregada: o servidor decide.
 */
export function trocaVale(codigos: CodigoNf[], cnae: string | null | undefined, troca: TrocaNf): boolean {
  const chave = chaveCombo(troca.nf_nbs, troca.nf_ind_operacao, troca.nf_class_trib);
  if (!chave) return true;
  const p = padraoDoCodigo(codigos, cnae);
  if (!p || !p.tem_tabela) return true;
  return p.combinacoes.some(c => chaveCombo(c.nbs, c.ind_operacao, c.class_trib) === chave);
}

/** Uma linha dizendo de onde vem o padrão: "rascunho" ou "confirmado pela contabilidade em dd/mm/aaaa". */
export function rotuloSituacao(p?: Pick<CodigoNf, 'situacao' | 'confirmado_por' | 'confirmado_em'> | null): string {
  if (!p) return 'sem padrão';
  if (p.situacao !== 'confirmado') return 'rascunho — a contabilidade ainda não confirmou';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(limpo(p.confirmado_em));
  return `confirmado pela contabilidade${m ? ` em ${m[3]}/${m[2]}/${m[1]}` : ''}${p.confirmado_por ? ` (${p.confirmado_por})` : ''}`;
}
